import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import InsumoRecord from '@components/InsumoRecord/InsumoRecord';
import formatMessage from './i18n/formatMessage';
import Insumo from '@resources/InsumosEnum';

/**
 * Componente para tela de Inseticidas microbiologicos
 *
 * @author Gabriela Farias <gabriela.farias@kepha.com.br>
 * @param {*} props
 * @returns {JSX.Element}
 */
function InseticidasMicroBio(props) {
  useEffect(() => {
    const title = 'inseticidaMicroBio.inseticidaMicroBio';
    if (props.itensState.name !== title) {
      props.dispatch({ type: 'UPDATE_TOOLBAR', toolbar: formatMessage(title), name: title });
    }
  }, []);

  return (
    <InsumoRecord
      chipData={props.chipData}
      infoUsuario={props.infoUsuario}
      insumoEnum={Insumo.INSETICIDA_MICROBIOLOGICO}
      insumoURL='inseticidas-microbiologicos'
      viewKey='inseticidasMicroBio'
      deleteMessageSucess={formatMessage(
        'inseticidaMicroBio.inseticidaMicroBioRemovidoComSucesso'
      )}
      mensagemFalhaDeletar={formatMessage('inseticidaMicroBio.falhaAoExcluirInseticidaMicroBio')}
      mensagemDelete={formatMessage('inseticidaMicroBio.desejaExcluir')}
    />
  );
}

const mapStateToProps = state => ({
  itensState: state.toolbar,
  infoUsuario: state.adicionarInfoUsuario.info,
  chipData: state.chips.chipData.filter(date => {
    return date.id === 'inseticidasMicroBio';
  })[0].content
});

export default connect(mapStateToProps)(InseticidasMicroBio);
